export const GET_PACKAGES_REQUEST = "GET_PACKAGES_REQUEST";
export const GET_PACKAGES_SUCCESS = "GET_PACKAGES_SUCCESS";
export const GET_PACKAGES_FAIL = "GET_PACKAGES_FAIL";
export const GET_PACKAGES_LIST_SUCCESS = "GET_PACKAGES_LIST_SUCCESS";

export const GET_PACKAGE_DETAILS_REQUEST = "GET_PACKAGE_DETAILS_REQUEST";
export const GET_PACKAGE_DETAILS_SUCCESS = "GET_PACKAGE_DETAILS_SUCCESS";
export const GET_PACKAGE_DETAILS_FAIL = "GET_PACKAGE_DETAILS_FAIL";
export const GET_PACKAGE_DETAILS_RESET = "GET_PACKAGE_DETAILS_RESET";

export const GET_USER_LOCATION_REQUEST = "GET_USER_LOCATION_REQUEST";
export const GET_USER_LOCATION_SUCCESS = "GET_USER_LOCATION_SUCCESS";
export const GET_USER_LOCATION_FAIL = "GET_USER_LOCATION_FAIL";

export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAIL = "GET_SERVICES_FAIL";

export const GET_SERVICE_DETAILS_REQUEST = "GET_SERVICE_DETAILS_REQUEST";
export const GET_SERVICE_DETAILS_SUCCESS = "GET_SERVICE_DETAILS_SUCCESS";
export const GET_SERVICE_DETAILS_FAIL = "GET_SERVICE_DETAILS_FAIL";
export const GET_SERVICE_DETAILS_RESET = "GET_SERVICE_DETAILS_RESET";
export const LOGIN_OTP_RESPONSE_CLEAR = "LOGIN_OTP_RESPONSE_CLEAR";

// send opt
export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";

// send otp
export const LOGIN_OTP_ERROR = "VERIFY_OTP_ERROR";
export const LOGIN_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const LOGIN_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";

// verified otp
export const OTP_VERIFICATION_ERROR = "OTP_VERIFICATION_ERROR";
export const OTP_VERIFICATION_REQUEST = "OTP_VERIFICATION_REQUEST";
export const OTP_VERIFICATION_SUCCESS = "OTP_VERIFICATION_SUCCESS";

// package fillup form

export const FORM_REQUEST = "FORM_REQUEST";
export const FORM_REQUEST_SUCESS = "FORM_REQUEST_SUCESS";
export const FORM_REQUEST_ERROR = "FORM_REQUEST_ERROR";

export const GET_CALL_REQUEST = "GET_CALL_REQUEST";
export const GET_CALL_SUCCESS = "GET_CALL_SUCCESS";
export const GET_CALL_FAIL = "GET_CALL_FAIL";
export const GET_CALL_RESET = "GET_CALL_RESET";

export const GET_CITIES_REQUEST = "GET_CITIES_REQUEST";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_FAIL = "GET_CITIES_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const GET_CITY_REQUEST = "GET_CITY_REQUEST";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_FAIL = "GET_CITY_FAIL";

export const SET_CITY_FAIL = "SET_CITY_FAIL";
export const CLEAR_CITY_FAIL = "CLEAR_CITY_FAIL";
export const SET_CITY_SUCCESS = "SET_CITY_SUCCESS";

export const SET_SEARCH_SUCCESS = "SET_SEARCH_SUCCESS";
export const SET_SEARCH_FAIL = "SET_SEARCH_FAIL";
export const SET_SEARCH_RESET = "SET_SEARCH_RESET";

export const GET_CUSTOMER_BOOKING_REQUEST = "GET_CUSTOMER_BOOKING_REQUEST";
export const GET_CUSTOMER_BOOKING_SUCCESS = "GET_CUSTOMER_BOOKING_SUCCESS";
export const GET_CUSTOMER_BOOKING_FAIL = "GET_CUSTOMER_BOOKING_FAIL";

export const GET_REPORT_REQUEST = "GET_REPORT_REQUEST";
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS";
export const GET_REPORT_FAIL = "GET_REPORT_FAIL";

export const GET_BLOG_REQUEST = "GET_BLOG_REQUEST";
export const GET_BLOG_SUCCESS = "GET_BLOG_SUCCESS";
export const GET_BLOG_FAIL = "GET_BLOG_FAIL";

export const GET_CUSTOMER_DASHBOARD_REQUEST = "GET_CUSTOMER_DASHBOARD_REQUEST";
export const GET_CUSTOMER_DASHBOARD_SUCCESS = "GET_CUSTOMER_DASHBOARD_SUCCESS";
export const GET_CUSTOMER_DASHBOARD_FAIL = "GET_CUSTOMER_DASHBOARD_FAIL";

//CUSTOMER DASHBOARD CONSTANT TONE DECLARE BELOW HERE
export const REGISTER_USER_VALIDATION = "REGISTER_USER_VALIDATION";

export const GET_TESTIMONIALS_REQUEST = "GET_TESTIMONIALS_REQUEST";
export const GET_TESTIMONIALS_SUCCESS = "GET_TESTIMONIALS_SUCCESS";
export const GET_TESTIMONIALS_FAIL = "GET_TESTIMONIALS_FAIL";

export const GET_BLOGS_REQUEST = "GET_BLOGS_REQUEST";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAIL = "GET_BLOGS_FAIL";

export const EDIT_PROFILE_REQUEST = "EDIT_PROFILE_REQUEST";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_ERROR = "EDIT_PROFILE_ERROR";

//GET ALL PACKAGE DATA
export const GET_ALL_PACKAGES_REQUEST = "GET_ALL_PACKAGES_REQUEST";
export const GET_ALL_PACKAGES_SUCCESS = "GET_ALL_PACKAGES_SUCCESS";
export const GET_ALL_PACKAGES_FAIL = "GET_ALL_PACKAGES_FAIL";
export const GET_ALL_PACKAGE_DETAILS_RESET = "GET_ALL_PACKAGE_DETAILS_RESET";

export const GET_ALL_IMG_PACKAGES_REQUEST = "GET_ALL_IMG_PACKAGES_REQUEST";
export const GET_ALL_IMG_PACKAGES_SUCCESS = "GET_ALL_IMG_PACKAGES_SUCCESS";
export const GET_ALL_IMG_PACKAGES_FAIL = "GET_ALL_IMG_PACKAGES_FAIL";

export const GET_ADDRESS_IMG_PACKAGES_REQUEST =
  "GET_ADDRESS_IMG_PACKAGES_REQUEST";
export const GET_ADDRESS_IMG_PACKAGES_SUCCESS =
  "GET_ADDRESS_IMG_PACKAGES_SUCCESS";
export const GET_ADDRESS_IMG_PACKAGES_FAIL = "GET_ADDRESS_IMG_PACKAGES_FAIL";
export const SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS =
  "SET_EMPTY_ADDRESS_IMG_PACKAGES_SUCCESS";

//REPORT PACAKGE DATA
export const GET_DIRECT_REPORT_REQUEST = "GET_DIRECT_REPORT_REQUEST";
export const GET_DIRECT_REPORT_SUCCESS = "GET_DIRECT_REPORT_SUCCESS";
export const GET_DIRECT_REPORT_FAIL = "GET_DIRECT_REPORT_FAIL";

//CAREERS FORM DATA
export const SEND_PROFILE_DATA = "SEND_PROFILE_DATA";
export const SEND_PROFILE_DATA_SUCCESS = "SEND_PROFILE_DATA_SUCCESS";
export const SEND_PROFILE_DATA_ERROR = "SEND_PROFILE_DATA_ERROR";

export const GET_JOB_REQUEST = "GET_JOB_REQUEST";
export const GET_JOB_REQUEST_SUCCESS = "GET_JOB_REQUEST_SUCCESS";
export const GET_JOB_REQUEST_FAIL = "GET_JOB_REQUEST_FAIL";

export const SMS_VERIFICATION_CANCEL = "SMS_VERIFICATION_CANCEL";
export const SMS_VERIFICATION_CANCEL_SUCCESS =
  "SMS_VERIFICATION_CANCEL_SUCCESS";
export const SMS_VERIFICATION_CANCEL_ERROR = "SMS_VERIFICATION_CANCEL_ERROR";
export const SMS_VERIFICATION_CONFIRM_ERROR = "SMS_VERIFICATION_CONFIRM_ERROR";
export const SMS_VERIFICATION_CONFIRM_SUCCESS =
  "SMS_VERIFICATION_CONFIRM_SUCCESS";
export const SMS_VERIFICATION_CONFIRM = "SMS_VERIFICATION_CONFIRM";

export const VIEW_BOOKING = "VIEW_BOOKING";
export const VIEW_BOOKING_SUCCESS = "VIEW_BOOKING_SUCCESS";
export const VIEW_BOOKING_ERROR = "VIEW_BOOKING_ERROR";

// upload prescription data
export const UPLOAD_PRESCRIPTION = "UPLOAD_PRESCRIPTION";
export const UPLOAD_PRESCRIPTION_SUCCESS = "UPLOAD_PRESCRIPTION_SUCCESS";
export const UPLOAD_PRESCRIPTION_ERROR = "UPLOAD_PRESCRIPTION_ERROR";

//usse landmark data

export const USERLAND_MARK = "USERLAND_MARK";
export const USERLAND_MARK_SUCCESS = "USERLAND_MARK_SUCCESS";
export const USERLAND_MARK_ERROR = "USERLAND_MARK_ERROR";

export const GET_PACKAGE_CATEGORY_REQUEST = "GET_PACKAGE_CATEGORY_REQUEST";
export const GET_PACKAGE_CATEGORY_SUCCESS = "GET_PACKAGE_CATEGORY_SUCCESS";
export const GET_PACKAGE_CATEGORY_FAIL = "GET_PACKAGE_CATEGORY_FAIL";

//news letter

export const NEWS_LETTER_REQUEST = "NEWS_LETTER_REQUEST";
export const NEWS_LETTER_SUCCESS = "NEWS_LETTER_SUCCESS";
export const NEWS_LETTER_ERRROR = "NEWS_LETTER_ERROR";

//unsubscribe

export const UNSUBSCRIEBE_REQUEST = "UNSUBSCRIEBE_REQUEST";
export const UNSUBSCRIEBE_REQUEST_SUCCESS = "UNSUBSCRIEBE_REQUEST_SUCCESS";
export const UNSUBSCRIEBE_REQUEST_ERROR = "UNSUBSCRIEBE_REQUEST_ERROR";

//CENTER

export const GET_CENTER_REQUEST = "GET_CENTER_REQUEST";
export const GET_CENTER_SUCCESS = "GET_CENTER_SUCCESS";
export const GET_CENTER_FAIL = "GET_CENTER_FAIL";

//collection

export const GET_CENTER_COLLECTION_REQUEST = "GET_CENTER_COLLECTION_REQUEST";
export const GET_CENTER_COLLECTION_SUCCESS = "GET_CENTER_COLLECTION_SUCCESS";
export const GET_CENTER_COLLECTION_FAIL = "GET_CENTER_COLLECTION_FAIL";

//pagination

export const PAGINATION_REQUEST = "PAGINATION_REQUEST";
export const PAGINATION_REQUEST_SUCCESS = "PAGINATION_REQUEST_SUCCESS";
export const PAGINATION_COLLECTION_FAIL = "PAGINATION_COLLECTION_FAIL";

export const LAB_PAGINATION_REQUEST = "LAB_PAGINATION_REQUEST";
export const LAB_PAGINATION_REQUEST_SUCCESS = "LAB_PAGINATION_REQUEST_SUCCESS";
export const LAB_PAGINATION_COLLECTION_FAIL = "LAB_PAGINATION_COLLECTION_FAIL";

export const CAREER_PAGINATION_REQUEST = "CAREER_PAGINATION_REQUEST";
export const CAREER_PAGINATION_REQUEST_SUCCESS =
  "CAREER_PAGINATION_REQUEST_SUCCESS";
export const CAREER_PAGINATION_COLLECTION_FAIL =
  "CAREER_PAGINATION_COLLECTION_FAIL";

//GET FAMILY AND FRIENDS DATA
export const GET_FAMILY_FRIENDS_DATA_REQUEST =
  "GET_FAMILY_FRIENDS_DATA_REQUEST";
export const GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS =
  "GET_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS";
export const GET_FAMILY_FRIENDS_DATA_FAIL = "GET_FAMILY_FRIENDS_DATA_FAIL";

export const POST_FAMILY_FRIENDS_DATA_REQUEST =
  "POST_FAMILY_FRIENDS_DATA_REQUEST";
export const POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS =
  "POST_FAMILY_FRIENDS_DATA_REQUEST_SUCCESS";
export const POST_FAMILY_FRIENDS_DATA_FAIL = "POST_FAMILY_FRIENDS_DATA_FAIL";

// My Addresses

export const GET_ALL_ADDRESS_REQUEST = "GET_ALL_ADDRESS_REQUEST";
export const GET_ALL_ADDRESS_REQUEST_SUCCESS =
  "GET_ALL_ADDRESS_REQUEST_SUCCESS";
export const GET_ALL_ADDRESS_REQUEST_FAIL = "GET_ALL_ADDRESS_REQUEST_FAIL";

export const CREATE_ADDRESS_REQUEST = "CREATE_ADDRESS_REQUEST";
export const CREATE_ADDRESS_REQUEST_SUCCESS = "CREATE_ADDRESS_REQUEST_SUCCESS";
export const CREATE_ADDRESS_REQUEST_FAIL = "CREATE_ADDRESS_REQUEST_FAIL";

export const EDIT_ADDRESS_REQUEST = "EDIT_ADDRESS_REQUEST";
export const EDIT_ADDRESS_REQUEST_SUCCESS = "EDIT_ADDRESS_REQUEST_SUCCESS";
export const EDIT_ADDRESS_REQUEST_FAIL = "EDIT_ADDRESS_REQUEST_FAIL";

//REPORT STATUS
export const GET_REPORT_REQUEST_USER = "GET_REPORT_REQUEST_USER";
export const GET_REPORT_SUCCESS_USER = "GET_REPORT_SUCCESS_USER";
export const GET_REPORT_ERROR_USER = "GET_REPORT_ERROR_USER";

//POST CART DATA
export const POST_CART_REQUEST = "POST_CART_REQUEST";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_CART_ERROR = "POST_CART_ERROR";
//Get cart details
export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_ERROR = "GET_CART_ERROR";

// delet cart data
export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS";
export const DELETE_CART_ERROR = "DELETE_CART_ERROR";

// delete cart multiple data
export const DELETE_MULTI_ITEMS_CART_REQUEST =
  "DELETE_MULTI_ITEMS_CART_REQUEST";
export const DELETE_MULTI_ITEMS_CART_SUCCESS =
  "DELETE_MULTI_ITEMS_CART_SUCCESS";
export const DELETE_MULTI_ITEMS_CART_ERROR = "DELETE_MULTI_ITEMS_CART_ERROR";

export const GET_TEST_PARAMETER = "GET_TEST_PARAMETER";
export const GET_TEST_PARAMETER_SUCCESS = "GET_TEST_PARAMETER_SUCCESS";
export const GET_TEST_PARAMETER_FAIL = "GET_TEST_PARAMETER_FAIL";
//download report

//export const GET_JOB_REQUEST_FAIL_USER ="GET_JOB_REQUEST_FAIL_USER";
//area pincode
export const GET_PINCODE_REQUEST = "GET_PINCODE_REQUEST";
export const GET_PINCODE_SUCCESS = "GET_PINCODE_SUCCESS";
export const GET_PINCODE_ERROR = "GET_PINCODE_ERROR";

//add new address for booking
export const POST_ADDRESS_REQUEST = "POST_ADDRESS_REQUEST";
export const POST_ADDRESS_REQUEST_SUCCESS = "POST_ADDRESS_REQUEST_SUCCESS";
export const POST_ADDRESS_FAIL = "POST_ADDRESS_FAIL";

//EXPORT CONSTANT
export const DELETE_ADDREESS_REQUEST = "DELETE_ADDREESS_REQUEST";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";
export const DELETE_ADDREESS_FAIL = "DELETE_ADDREESS_FAIL";

export const POST_PAYMENT_INFO = "POST_PAYMENT_INFO";
export const POST_PAYMENT_INFO_SUCCESS = "POST_PAYMENT_INFO_SUCCESS";
export const POST_PAYMENT_INFO_FAIL = "POST_PAYMENT_INFO_FAIL";

//create booking
export const CREATE_BOOKING_REQUEST = "CREATE_BOOKING_REQUEST";
export const CREATE_BOOKING_SUCCESS = "CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_ERROR = "CREATE_BOOKING_ERROR";
export const EMPTY_REDUCER = "EMPTY_REDUCER";

export const UPLOAD_PRESCRIPTION_LP = "UPLOAD_PRESCRIPTION_LP";
export const UPLOAD_PRESCRIPTION_SUCCESS_LP = "UPLOAD_PRESCRIPTION_SUCCESS_LP";
export const UPLOAD_PRESCRIPTION_ERROR_LP = "UPLOAD_PRESCRIPTION_ERROR_LP";

//empty cart
export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";
export const EMPTY_CART_SUCCESS = "EMPTY_CART_SUCCESS";
export const EMPTY_CART_FAIL = "EMPTY_CART_FAIL";

export const EPMTY_CART_OBJECT = "EPMTY_CART_OBJECT";
export const EPMTY_REPORT_OJECT = "EPMTY_REPORT_OJECT";

//STORE SELECTED SLOT IN REEDUCER

export const SELECT_SLOT = "SELECT_SLOT";

//APPLY COUPN CODE
export const GET_COUPON_CODE_REQUEST = "GET_COUPON_CODE_REQUEST";
export const GET_COUPON_CODE_SUCCESS = "GET_COUPON_CODE_SUCCESS";
export const GET_COUPON_CODE_ERROR = "GET_COUPON_CODE_ERROR";

export const SET_ADDON_TRUE = "SET_ADDON_TRUE";
export const SET_ADDON_FALSE = "SET_ADDON_FALSE";

///feedback
export const ADD_FEEDBACK_REQUEST = "ADD_FEEDBACK_REQUEST";
export const ADD_FEEDBACK_SUCCESS = "ADD_FEEDBACK_SUCCESS";
export const ADD_FEEDBACK_FAIL = "ADD_FEEDBACK_FAIL";

//redcash
export const GET_REDCASH = "GET_REDCASH";
export const GET_REDCASH_SUCCESS = "GET_REDCASH_SUCCESS";
export const GET_REDCASH_FAIL = "GET_REDCASH_FAIL";

export const GET_REDCASH_DETAILS = "GET_REDCASH_DETAILS";
export const GET_REDCASH_DETAILS_SUCCESS = "GET_REDCASH_DETAILS_SUCCESS";
export const GET_REDCASH_DETAILS_FAIL = "GET_REDCASH_DETAILS_FAIL";
//

export const GET_IMG_PACKAGES_SUCCESS = "GET_IMG_PACKAGES_SUCCESS";
export const GET_IMG_PACKAGES_REQUEST = "GET_IMG_PACKAGES_REQUEST";
export const GET_IMG_PACKAGES_FAIL = "GET_IMG_PACKAGES_FAIL";

export const SET_CENTERADDRESS_SUCCESS = "SET_CENTERADDRESS_SUCCESS";
export const SET_CENTERADDRESS_FAIL = "SET_CENTERADDRESS_FAIL";
export const CLEAR_CENTERADDRESS = "CLEAR_CENTERADDRESS";

export const GET_CARRERDATA = "GET_CARRERDATA";
export const GET_CARRERDATA_SUCCESS = "GET_CARRERDATA_SUCCESS";
export const GET_CARRERDATA_FAIL = "GET_CARRERDATA_FAIL";

export const GET_IMG_TIME_SLOT_REQUEST = "GET_IMG_TIME_SLOT_REQUEST";
export const GET_IMG_TIME_SLOT_SUCCESS = "GET_IMG_TIME_SLOT_SUCCESS";
export const GET_IMG_TIME_SLOT_ERROR = "GET_IMG_TIME_SLOT_ERROR";

export const GET_DETAILS_IMG_PACKAGES_REQUEST =
  "GET_DETAILS_IMG_PACKAGES_REQUEST";
export const GET_DETAILS_IMG_PACKAGES_SUCCESS =
  "GET_DETAILS_IMG_PACKAGES_SUCCESS";
export const GET_DETAILS_IMG_PACKAGES_FAIL = "GET_DETAILS_IMG_PACKAGES_FAIL";
export const GET_DETAILS_IMG_PACKAGES_RESET = "GET_DETAILS_IMG_PACKAGES_RESET";

//

export const GET_IMAGINE_TESTIMONIALS_REQUEST =
  "GET_IMAGINE_TESTIMONIALS_REQUEST";
export const GET_IMAGINE_TESTIMONIALS_SUCCESS =
  "GET_IMAGINE_TESTIMONIALS_SUCCESS";
export const GET_IMAGINE_TESTIMONIALS_FAIL = "GET_IMAGINE_TESTIMONIALS_FAIL";

//
export const RESET_FEDBACK = "RESET_FEDBACK";

export const GET_MAP_MY_INDIA_ACCESS_TOKEN = "GET_MAP_MY_INDIA_ACCESS_TOKEN";
export const GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS =
  "GET_MAP_MY_INDIA_ACCESS_TOKEN_SUCCESS";
export const GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL =
  "GET_MAP_MY_INDIA_ACCESS_TOKEN_FAIL";

export const GET_CITY_MAIN_REQUEST = "GET_CITY_MAIN_REQUEST";
export const GET_CITY_MAIN_SUCCESS = "GET_CITY_MAIN_SUCCESS";
export const GET_CITY_MAIN_FAIL = "GET_CITY_MAIN_FAIL";

export const GET_USER_CURRENT_LOCATION_REQUEST =
  "GET_USER_CURRENT_LOCATION_REQUEST";
export const GET_USER_CURRENT_LOCATION_SUCCESS =
  "GET_USER_CURRENT_LOCATION_SUCCESS";
export const GET_USER_CURRENT_LOCATION_FAIL = "GET_USER_CURRENT_LOCATION_FAIL";

export const SET_ISLOGOUT_FAIL = "SET_ISLOGOUT_FAIL";
export const SET_ISLOGOUT_SUCCESS = "SET_ISLOGOUT_SUCCESS";

export const GET_EVENTS = "GET_EVENTS";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export const GET_EVENTS_FAILS = "GET_EVENTS_FAIL";

export const POST_EVENT_REGISTRATION = "POST_EVENT_REGISTRATION";
export const POST_EVENT_REGISTRATION_SUCCESS =
  "POST_EVENT_REGISTRATION_SUCCESS";
export const POST_EVENT_REGISTRATION_FAIL = "POST_EVENT_REGISTRATION_FAIL";

export const GET_STATE_REQUEST = "GET_STATE_REQUEST";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_ERROR = "GET_STATE_ERROR";


export const POST_FEANCHISE_FORM_REQUEST = "POST_FEANCHISE_FORM_REQUEST"
export const POST_FEANCHISE_FORM_SUCCESS = "POST_FEANCHISE_FORM_SUCCESS"
export const POST_FEANCHISE_FORM_ERROR = "POST_FEANCHISE_FORM_ERROR"

export const VERFIY_USER_REQUEST = "VERFIY_USER_REQUEST";
export const VERFIY_USER_SUCCESS = "VERFIY_USER_SUCCESS";
export const VERFIY_USER_FAIL = "VERFIY_USER_FAIL";
///order_payment_link_status 

export const GET_PRESCRIPTION_DATA_REQUEST = "GET_PRESCRIPTION_DATA_REQUEST"
export const GET_PRESCRIPTION_DATA_SUCCESS = "GET_PRESCRIPTION_DATA_SUCCESS"
export const GET_PRESCRIPTION_DATA_FAIL = "GET_PRESCRIPTION_DATA_FAIL"

// Family Cart Data
export const GET_FAMILY_CART_DATA_REQUEST = "GET_FAMILY_CART_DATA_REQUEST";
export const GET_FAMILY_CART_DATA_SUCCESS = "GET_FAMILY_CART_DATA_SUCCESS";
export const GET_FAMILY_CART_DATA_FAIL = "GET_FAMILY_CART_DATA_FAIL";


export const GET_CARRER_DATA_JOB_POSTING = "GET_CARRER_DATA_JOB_POSTING";
export const GET_CARRER_DATA_JOB_POSTING_SUCCESS = "GET_CARRER_DATA_JOB_POSTING_SUCCESS";
export const GET_CARRER_DATA_JOB_POSTING_FAIL = "GET_CARRER_DATA_JOB_POSTING_FAIL";


{/**  notes: {
          gift_card:true,
          uuid:"user+_id"
        } */}
